"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CardProductHeader = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Clear = require("../../../base-components/Clear/Clear");
var _ButtonWithIcon = require("../../../base-components/Button/variants/ButtonWithIcon/ButtonWithIcon");
var _svgFetcher = _interopRequireDefault(require("../../../utils/svgFetcher"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var CardProductHeader = exports.CardProductHeader = function CardProductHeader(_ref) {
  var ImageComponent = _ref.ImageComponent,
    imageComponentProps = _ref.imageComponentProps,
    TitleComponent = _ref.TitleComponent,
    titleComponentProps = _ref.titleComponentProps,
    styles = _ref.styles,
    namespace = _ref.namespace,
    qeId = _ref.qeId,
    collapsableOnMobile = _ref.collapsableOnMobile,
    toggleCollapsed = _ref.toggleCollapsed,
    collapsed = _ref.collapsed,
    buttonSvg = _ref.buttonSvg,
    ariaCardTitle = _ref.ariaCardTitle;
  var forText = ariaCardTitle ? " for ".concat(ariaCardTitle) : '';
  var ariaLabelVal = "".concat(collapsed ? 'Open' : 'Close', " Details").concat(forText);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: styles.productHeader
  }, /*#__PURE__*/_react["default"].createElement(ImageComponent, _extends({}, imageComponentProps, {
    namespace: namespace,
    "data-qe-id": qeId ? "".concat(qeId, "-image") : undefined
  })), /*#__PURE__*/_react["default"].createElement(TitleComponent, _extends({}, titleComponentProps, {
    namespace: namespace,
    "data-qe-id": qeId ? "".concat(qeId, "-title") : undefined
  })), collapsableOnMobile && /*#__PURE__*/_react["default"].createElement(_ButtonWithIcon.ButtonWithIcon, {
    Svg: buttonSvg,
    onClick: toggleCollapsed,
    toggled: collapsed,
    styles: styles,
    ariaLabel: ariaLabelVal,
    ariaExpanded: !collapsed,
    iconHiddenToScreenReader: true,
    collapsed: collapsed
  }), /*#__PURE__*/_react["default"].createElement(_Clear.Clear, null));
};
CardProductHeader.propTypes = {
  ImageComponent: _propTypes["default"].oneOfType([_propTypes["default"].node, _propTypes["default"].func]),
  imageComponentProps: _propTypes["default"].objectOf(_propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].object])),
  TitleComponent: _propTypes["default"].oneOfType([_propTypes["default"].node, _propTypes["default"].func]),
  titleComponentProps: _propTypes["default"].objectOf(_propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].object, _propTypes["default"].objectOf(_propTypes["default"].object)])),
  styles: _propTypes["default"].objectOf(_propTypes["default"].string),
  namespace: _propTypes["default"].string,
  qeId: _propTypes["default"].string,
  collapsableOnMobile: _propTypes["default"].bool,
  toggleCollapsed: _propTypes["default"].func,
  collapsed: _propTypes["default"].bool,
  buttonSvg: _propTypes["default"].oneOfType([_propTypes["default"].element, _propTypes["default"].func])
};
CardProductHeader.defaultProps = {
  ImageComponent: 'div',
  imageComponentProps: {},
  TitleComponent: 'div',
  titleComponentProps: {},
  styles: {},
  namespace: '',
  qeId: undefined,
  collapsableOnMobile: false,
  toggleCollapsed: function toggleCollapsed() {},
  collapsed: false,
  buttonSvg: function buttonSvg() {
    return (0, _svgFetcher["default"])('dls-icon-up', 'dls');
  }
};